import { Role, rolesManipulator } from 'auth';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { adminDashboardPaths } from '@/modules/admin-dashboard/routes.tsx';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { entityPaths } from '@/modules/entity/routes.tsx';
import { issuerDashboardPaths } from '@/modules/issuer-dashboard/routes.tsx';
import { Spinner } from 'ui';

export const mapRoleToDefaultRoute: Partial<Record<Role, string>> = {
  [Role.SR_INVESTOR]: entityPaths.static.entityList,
  [Role.SR_ISSUER]: issuerDashboardPaths.static.dashboard,
  [Role.SR_ISSUER_ADMIN]: issuerDashboardPaths.static.dashboard,
  [Role.SR_ADMIN]: adminDashboardPaths.static.registers,
};

const RootRoute = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    if (!rolesManipulator.current_user_role) return;

    const roleDefaultRoute = mapRoleToDefaultRoute[rolesManipulator.current_user_role];

    if (auth.isAuthenticated && roleDefaultRoute) {
      navigate({ pathname: roleDefaultRoute, search: params.toString() });
    }
  }, [auth.isAuthenticated, navigate, params]);

  return (
    <div className="w-full h-full flex items-center justify-center">
      <Spinner size="lg" />
    </div>
  );
};

export default withPrivateAccess(RootRoute, [
  Role.SR_ISSUER,
  Role.SR_ISSUER_ADMIN,
  Role.SR_INVESTOR,
  Role.SR_ADMIN,
]);
